const lightThemeVariables = {
  mode: "light",
  font_color: "rgba(0, 0, 0, 0.65)",
  danger_color: "#ff4d4f",
  primary_color: "#1890ff",
  hover_color: "#e6f7ff",
  base_color: "#f4f5f6",
  disabled_color: "#BDBDBD",
  background_color: "#fff",
  border_color: "#E2E2E2",
  statusColors: {
    UNDERREVIEW: "#f5a142",
    APPROVE: "#1890ff",
    DISAPPROVE: "#BDBDBD",
    PENDING: "#d65b36",
    PUBLIC: "#7ce630",
    REJECT: "#ff4d4f",
    DESTROY: "#ff4d4f",
    ACTIVE: "#1890ff",
    INACTIVE: "#BDBDBD",
    READY: "#00897B",
    COMPLETE: "#3949AB",
    ARCHIVE: "#f7606b",
    CONFIRMED: "#499156",
    DELIVERED: "#499156",
    CANCELED: "#ED2B2E",
    RETURNED: "#FF9F40",
    DRAFT: "#BDBDBD",
    CONFIRM: "#499156",
    PAID: "#3949AB",
    PAY_SUCCESS: "#499156",
    PAY_FAIL: "#ff4d4f",
    VERIFY_FAILED: "#ff4d4f",
    VERIFYING: "#499156",
    PAY_ONHOLD: "#d65b36",
    APPROVED: "#177ddc",
    REGISTERED: "#f5a142",
    REGISTER_FAILED: "#ff4d4f",
    SAVED: "#1890ff",
    PROCESSING: "#499156",
    BANK_REJECTED: "#ff4d4f",
  },
};

export default lightThemeVariables;
